// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildQuery(data: any): string {
  return new URLSearchParams(data).toString();
}